import {Module, Component} from '../decorators';
import R from 'app/resource';

import BasePicker from './base.picker';
import cropTpl from './crop.picker.tpl.html';


@Module({
    name: "app.orders.compontents.crop",
    modules: [R],
})
@Component({
    selector: 'blnd-crop-picker',
    template: cropTpl,
    bindings: {
        ngModel: '=',
        ngChange: '&?',
    },
})
export default class C extends BasePicker {
    constructor ($scope, $element, R) {
        "ngInject";
        super($element);

        this.scope = $scope;
        this.R = R;
        this.list = [];
        this.endpoint = R.one('crops');
    }

    refresh () {
        if (!this.enabled) { return; }

        let self = this;
        return this.endpoint.getList().then(function (response) {
            self.list = response.plain();
            return self;
        });
    }

    $onInit () {
        let self = this;
        this.watcher = this.scope.$watch(() => this.ngModel, function () {
            self.onChange();
        });
    }

    onChange () {
        if (this.ngChange) {
            this.ngChange();
        }
    }

    $onDestroy () {
        delete this.list;
        super.$onDestroy();
    }
}



// WEBPACK FOOTER //
// ./src/app/directives/crop.picker.js